import MarkdownIt from 'markdown-it';

export default class HtmlizedText {

    private currentText: string;

    constructor(text: string) {
        this.currentText = text;
    }

    public getMe(): string {
        return this.currentText;
    }

    public htmlize(parser: MarkdownIt): void {
        this.currentText = parser.render(this.currentText);
    }

    public removeEnclosingParagraph(): void {
        let paragraphs = this.currentText.match(/<p>/);
        if(paragraphs != null && paragraphs.length == 1) {
            this.currentText = this.currentText.replace(/^(?:<p>)?(.*?)(?:<\/p>\n)?$/, '$1');
        }
    }
}